import { Directive, Input, TemplateRef, ViewContainerRef, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appLazyRender]'
})
export class LazyRenderDirective implements AfterViewInit {
  @Input('template') template!: TemplateRef<any>;

  constructor(private vcr: ViewContainerRef, private el: ElementRef) {}

  ngAfterViewInit() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vcr.createEmbeddedView(this.template);
          observer.disconnect(); // Deja de observar
        }
      });
    });

    // Observamos el div donde está aplicada la directiva, no el template
    observer.observe(this.el.nativeElement);
  }
}
